module.exports = __webpack_public_path__ + "9a718ca7ddc297cd55193f5d3770d3b5.svg";


//////////////////
// WEBPACK FOOTER
// ./images/combined-shape2.svg
// module id = 102
// module chunks = 0